<div class="step-container">
  <div class="step-indicator"
    [ngClass]="{'current-step': isCurrentStep, 'completed-step': isCompleted}">
    @if (isCompleted) {
      <i class="fas fa-check"></i>
    }
    @if (!isCompleted) {
      <span class="step-dot-inner" [ngClass]="{'active': isCurrentStep}"></span>
    }
  </div>
  <div class="step-description" (click)="handleStepClick()"
  [ngClass]="{'current-step': isCurrentStep, 'has-click-handler': action!==null}">{{displayText}}</div>
</div>
